import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaPaintRoller, FaMobileAlt, FaImages, FaMapMarkerAlt, FaUsers, FaCode, FaRocket, FaSearch, FaFileInvoice } from 'react-icons/fa';
import Button from '../../components/Button';

const WebPintorPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Consigue clientes mientras trabajas",
      description: "Tu web trabaja 24/7, atrayendo posibles proyectos incluso cuando estás ocupado en una obra. Muestra tus servicios y presupuestos siempre disponibles."
    },
    {
      title: "Crea confianza con tu trabajo",
      description: "El 82% de los clientes buscan ver fotos de trabajos anteriores antes de contratar. Muestra un portfolio profesional que demuestre tu calidad y experiencia."
    },
    {
      title: "Diferénciate de otros pintores",
      description: "El 68% de los pintores profesionales aún no tienen presencia online adecuada. Destaca con una web profesional que transmita seriedad y confianza."
    },
    {
      title: "Posiciónate localmente en Google",
      description: "Aparece cuando buscan 'pintor en [tu zona]'. El 89% de las búsquedas de servicios de pintura y decoración incluyen términos de proximidad."
    },
    {
      title: "Explica claramente tus servicios",
      description: "Detalla los tipos de pintura, acabados, técnicas decorativas y servicios adicionales que ofreces. Atrae al cliente que busca exactamente lo que haces."
    },
    {
      title: "Recupera la inversión rápidamente",
      description: "Con solo 1-2 proyectos nuevos que lleguen por la web, recuperas completamente la inversión. Después todo son beneficios para tu negocio."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaPaintRoller />,
      title: "Catálogo visual de servicios",
      description: "Presentación profesional de todos tus servicios: pintura interior, exterior, decorativa, técnicas especiales. Descripciones claras con precios orientativos."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño 100% adaptado a móviles",
      description: "El 73% de las búsquedas de servicios de pintura se hacen desde el móvil. Tu web será perfecta en cualquier dispositivo, generando más contactos."
    },
    {
      icon: <FaImages />,
      title: "Portfolio profesional de trabajos",
      description: "Galería de imágenes antes/después organizada por tipos de proyectos. Muestra tus mejores trabajos para generar confianza inmediata en tu calidad."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Optimización SEO local avanzada",
      description: "Configuración para Google Maps y Google Business Profile. Aparece cuando busquen pintores cerca con toda tu información actualizada."
    },
    {
      icon: <FaFileInvoice />,
      title: "Solicitud de presupuestos online",
      description: "Formulario específico para solicitar presupuestos, indicando tipo de trabajo, medidas y preferencias. Ahorra tiempo en visitas innecesarias."
    },
    {
      icon: <FaSearch />,
      title: "SEO específico para pintores",
      description: "Posicionamiento para términos como 'pintor en [tu zona]' o tus especialidades. Optimización de contenidos para atraer a tu cliente ideal."
    }
  ];
  
  // Planes de precios estandarizados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para pintores autónomos que necesitan una web sencilla pero profesional para comenzar su presencia online.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=basico',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por pintores. Equilibrio perfecto entre precio y funcionalidades para captar más clientes.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=estandar',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para pintores que quieren destacar con más funcionalidades y mejor posicionamiento en el sector de la pintura y decoración.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=avanzado',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Estudiamos tu negocio, servicios y especialidades. Planificamos una web que transmita profesionalidad y calidad en tus acabados.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos una web con diseño elegante y profesional. Implementamos todas las secciones necesarias para mostrar tus trabajos y servicios.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos en su uso y configuramos estrategias SEO local para que te encuentren los clientes de tu zona.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño específico para pintores",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Portfolio profesional antes/después",
      us: true,
      others: false
    },
    {
      label: "Formulario específico para presupuestos",
      us: true,
      others: false
    },
    {
      label: "Explicación clara de técnicas y acabados",
      us: true,
      others: false
    },
    {
      label: "Formación en actualización de portfolio",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Siempre pensé que una web era un lujo innecesario para un pintor, pero me equivocaba. Desde que tengo presencia online profesional estoy recibiendo un tipo de cliente diferente, que valora la calidad y busca acabados especiales. La web me permite mostrar mi portfolio de manera impecable y explicar mis servicios con detalle. Los clientes llegan a la primera cita mucho más informados y con ideas más claras. La sección de antes/después ha sido clave para demostrar la calidad de mi trabajo. He recuperado la inversión en menos de tres meses y ahora gran parte de mis nuevos clientes vienen por la web.",
    author: "Miguel Sánchez",
    position: "Pintor profesional",
    company: "Pinturas y Decoración Sánchez",
    avatar: "/servicios/testimonios/pintor.webp"
  };
  
  const founderMessage = "En el mundo de la pintura profesional, el componente visual es decisivo. Diseñamos webs con un enfoque en mostrar el antes y después de los trabajos, destacando la calidad de los acabados y las técnicas especializadas. Un pintor con un portfolio digital bien estructurado logra transmitir confianza desde el primer momento y atraer clientes que valoran la calidad por encima del precio.";
  
  // FAQs específicas para web de pintores
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional como pintor?",
      answer: "Una web profesional es crucial para pintores por diversos motivos estratégicos: 1) El 82% de los clientes buscan referencias visuales antes de contratar servicios de pintura y decoración; 2) Te permite mostrar un portfolio organizado de trabajos anteriores, fundamental para generar confianza; 3) Facilita la explicación detallada de técnicas, acabados y tipos de pintura que ofreces; 4) Te posiciona en Google Maps y búsquedas locales como 'pintor en [tu zona]', fundamentales para captar clientes de proximidad; 5) Permite mostrar testimonios y recomendaciones de clientes anteriores, claves en un sector donde la confianza es decisiva; 6) Te diferencia de la competencia no profesional, destacando tu experiencia y calidad; 7) Actúa como asistente 24/7, recibiendo solicitudes de presupuesto incluso mientras trabajas en otros proyectos. Los pintores con presencia web profesional reportan un incremento medio del 34% en proyectos de mayor valor añadido (técnicas decorativas, acabados especiales) en comparación con los que dependen solo de referidos tradicionales.",
      category: "Beneficios"
    },
    {
      question: "¿Cómo se mostrarán mis trabajos en la web?",
      answer: "Tu portfolio se presentará de forma profesional y optimizada para generar máxima confianza: 1) Galería principal organizada por categorías (interiores, exteriores, decorativa, etc.) permitiendo al cliente navegar según sus intereses; 2) Sección destacada de antes/después, crucial para demostrar la transformación y calidad de tu trabajo; 3) Fichas de proyectos completos con descripción del trabajo, técnicas utilizadas, duración y testimonios del cliente; 4) Optimización técnica de las imágenes para mostrar los detalles de acabados y texturas sin ralentizar la carga; 5) Sistema de zoom para apreciar detalles en acabados especiales; 6) Posibilidad de incluir breves vídeos de procesos especiales; 7) Sección específica para cada tipo de servicio con ejemplos correspondientes. Implementaremos un sistema intuitivo para que puedas añadir fácilmente nuevos trabajos a tu portfolio desde tu móvil o ordenador. La calidad fotográfica es esencial, por lo que te ofreceremos recomendaciones para tomar mejores fotos o contactar con fotógrafos especializados si lo necesitas.",
      category: "Contenidos"
    },
    {
      question: "¿Incluís un sistema de presupuestos online?",
      answer: "Los sistemas de presupuestos online no están incluidos en los precios base y se presupuestan por separado según tu modelo de trabajo: 1) Sistema básico de solicitud de presupuestos (desde 80€) - Formulario avanzado donde el cliente especifica tipo de trabajo, medidas, preferencias y puede adjuntar fotos, recibiendo tú una notificación detallada; 2) Sistema intermedio con calculadora simple (desde 150€) - Para servicios estándar donde el cliente puede obtener un presupuesto aproximado según metros cuadrados y tipo de pintura; 3) Sistema avanzado personalizado (desde 300€) - Plataforma completa con calculadora detallada, selección de tipos de superficie, acabados, accesos y otros factores específicos que afectan al presupuesto. Estos sistemas son complementos opcionales a la web que requieren configuración específica según tu forma de trabajar y calcular presupuestos. También pueden incluir funcionalidades como seguimiento de proyectos o calendario de disponibilidad. El presupuesto exacto se determina tras analizar cómo calculas tus precios y qué nivel de automatización es viable para tu negocio.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cuántas páginas incluye cada plan?",
      answer: "Cada plan incluye un número limitado de páginas para mantener la relación calidad-precio: 1) El plan Básico (200€) incluye hasta 5 páginas principales: inicio, servicios, portfolio, sobre mí y contacto; 2) El plan Profesional (300€) permite entre 5-10 páginas, añadiendo secciones como técnicas específicas, tipos de pintura, trabajos por categorías, testimonios detallados o proceso de trabajo; 3) El plan Premium (400€) permite entre 10-15 páginas, pudiendo incluir páginas específicas para cada servicio, blog de consejos de decoración, guías de color, mantenimiento de pinturas, colaboraciones, etc. Si necesitas más páginas de las incluidas en tu plan, tienen un coste adicional de 40€ por página. Para webs realmente extensas con más de 15 páginas, recomendamos solicitar un presupuesto personalizado. La experiencia nos muestra que para la mayoría de pintores, el plan Profesional ofrece el equilibrio perfecto entre inversión y resultados, ya que permite mostrar adecuadamente todos los servicios y un portfolio completo.",
      category: "Planes"
    },
    {
      question: "¿Qué fotos utilizaréis en mi web?",
      answer: "Las imágenes son el elemento más importante para una web de pintor, ya que muestran directamente la calidad de tu trabajo. Tienes estas opciones: 1) Fotografías propias: Si dispones de imágenes de calidad de tus trabajos anteriores, las optimizaremos y utilizaremos como base principal; 2) Sesión fotográfica profesional: Podemos recomendarte fotógrafos especializados en interiorismo y acabados (presupuesto aproximado: 200-250€ por sesión); 3) Guía fotográfica: Te proporcionaremos una guía detallada para que puedas tomar mejores fotos de tus trabajos con tu móvil, incluyendo consejos sobre iluminación y ángulos; 4) Imágenes mixtas: Para secciones generales podemos complementar con algunas imágenes de stock de alta calidad. Para el portfolio, es crucial mostrar trabajos reales con fotos de antes/después cuando sea posible. Te recomendaremos establecer una rutina de documentación fotográfica de tus proyectos para ir ampliando el portfolio de forma continua. La calidad de las imágenes influye directamente en la percepción de profesionalidad y en las tasas de conversión de la web.",
      category: "Contenidos"
    },
    {
      question: "¿Cómo funcionará el mantenimiento de la web?",
      answer: "El mantenimiento mensual de 20€ incluye servicios esenciales para el funcionamiento óptimo de tu web: 1) Alojamiento en servidores de alta velocidad, especialmente optimizados para cargar rápidamente las galerías de imágenes; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL; 4) Copias de seguridad diarias; 5) Actualizaciones de seguridad y del sistema; 6) Soporte técnico por email y teléfono; 7) Pequeñas modificaciones de contenido (hasta 30 minutos mensuales); 8) Monitorización de rendimiento. Te proporcionaremos acceso a un panel intuitivo donde podrás añadir nuevos trabajos a tu portfolio, actualizar servicios o modificar precios orientativos. Para pintores, es especialmente útil poder actualizar el portfolio regularmente con nuevos proyectos terminados. El mantenimiento es obligatorio para garantizar el correcto funcionamiento de la web, asegurar la renovación del dominio y el alojamiento seguro de los contenidos.",
      category: "Mantenimiento"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para pintores
      pageTitle="Web para Pintores desde 200€ | Muestra tus Trabajos Profesionalmente"
      pageDescription="Diseño web especializado para pintores profesionales. Destaca tus trabajos, técnicas y servicios con un portfolio impactante. Optimizada para atraer clientes en tu zona."
      pageKeywords="página web barata pintor, web para pintores, diseño web pintores, página web decoración barata, web pintor económica"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-pintor"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para pintores desde 200€ (atrae clientes mientras pintas)"
      heroSubtitle="Diseño web profesional para pintores. Muestra tu trabajo, técnicas y experiencia. Optimizada para atraer clientes de tu zona."
      heroImage="/servicios/tipo-cliente/hero-pintores.webp"
      badges={['Desde 200€ (pago único)', 'Galería de trabajos', 'Optimización local', 'Mantenimiento 20€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de pintor"
      pricingSubtitle="Elige el plan que mejor se adapte a las necesidades de tu negocio. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para pintores?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Miguel Vela"
            founderTitle="Co-fundador y Director de Desarrollo"
            avatarSrc="/sobre nosotros/foto-miguel.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu web de pintor?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de una web profesional para pintores"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para pintores"
      faqCategories={["Beneficios", "Contenidos", "Funcionalidades", "Planes", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu negocio de pintura con presencia online profesional"
      ctaDescription="Una inversión inteligente que atraerá nuevos clientes, mostrará la calidad de tus trabajos y diferenciará tu servicio de la competencia. Recupera la inversión rápidamente."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebPintorPage; 

